"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightGray = exports.gray = exports.gr = exports.black = void 0;
var _styledComponents = require("styled-components");
var _LexusTypography = require("../../../components/LexusTypography");
var _index = require("./index.styled");
const lightGray = exports.lightGray = (0, _styledComponents.css)`
  color: #000;
  background-color: #EAEAEA;
`;
const gray = exports.gray = (0, _styledComponents.css)`
  color: #FFF;
  background-color: #3A3B3C;
`;
const black = exports.black = (0, _styledComponents.css)`
  color: #FFF;
  background-color: #000;
`;
const gr = exports.gr = (0, _styledComponents.css)`
 ${_index.Heading}{
    ${(0, _LexusTypography.decimaMonoPro)({
  sizing: "heading40"
})}
    color: #E60010;
  }
`;